// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from "firebase/app";
import { setupVersionListener } from './checkForUpdates';
import 'firebase/messaging';
import "firebase/auth";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Make BootstrapVue available throughout your project
import "firebase/storage"
import '@flaticon/flaticon-uicons/css/all/all.css'
import { db } from '../src/firebase';
import moment from 'moment';

// استدعاء مراقب التحديثات قبل إنشاء التطبيق
// setupVersionListener();

Vue.config.productionTip = false;
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
function getPlatformInfo() {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua) && /Safari/.test(ua) && !/CriOS|FxiOS/.test(ua)) {
    return "iOS Safari";
  }
  if (/Android/.test(ua)) {
    return "Android";
  }
  return "Web";
};
if (firebase.messaging.isSupported()) {
  const messaging = firebase.messaging();

  Notification.requestPermission()
    .then((permission) => {
      if (permission === 'granted') {
        return messaging.getToken({
          vapidKey: "BBpB8VEQrmGfwrz6hd3NmxVT4tdp8XY_izsV49cHeq0z4F_FSLhrlJEaKgv7SU3APGboU2dTnAx1IiHmpG3m8tM"
        });
      } else {
        console.warn("🚫 تم رفض صلاحية الإشعارات");
      }
    })
    .then((token) => {
      if (token) {
        let user = JSON.parse(localStorage.getItem("User"));

        console.log("✅ Token:", token);
        alert(token)
        // احفظ الـ token في Firestore تحت collection "deviceTokens"
        db.collection("deviceTokens").doc(token).set({
          createdAt: new Date(),
          userID: user.userID || null,
          username: user.username || null,
          role: user.role || 'user',
          platform: getPlatformInfo()
        });
      }
    })
    .catch((err) => {
      console.error("❌ فشل في جلب Token", err);
    });

  // استقبال الإشعارات داخل التطبيق
messaging.onMessage((payload) => {
  console.log("📬 رسالة واردة أثناء الاستخدام:", payload);

  const { title, body, image } = payload.notification;

  const options = {
    body,
    icon: '/icons/icon-192x192.png',
    image: image || undefined
  };

  // عرض الإشعار يدويًا
  if (Notification.permission === "granted") {
    new Notification(title, options);
  } else {
    console.warn("🔕 الإشعارات غير مفعّلة");
  }
});

}

let app = '';
  if(!app){
    new Vue({
      el: '#app',
      router,
      template: '<App/>',
      components: { App },

      data (){
        
        return {
          selectedOrderObj: null,
          selectedOrderIndex: -1,
          orders : [],
          loggedUser: null,
          totalOrdersForToday:0,
          Cheques:[],
          Users:[],
          totalCheques:0,
          totalExpenses:0,
          cheque:{
          dealerName:'',
          amount:0,
          date:'',
          createdDate: moment().format('LLLL'),
          checked: false,
          Expenses:[],
          fromDate: '',
          toDate:'',
          chequesSearch:'',
          chequesCounter:0,
          chequesTrue:0,
          chequesFalse:0,
          userData:null,
          loggedUserData:null,
          isAuth:null

    
      },
        }
      },
      created(){
        let user = localStorage.getItem("User");
        let vm = this;
        // console.log('The Params is: ' + vm.$route.path);
        vm.fromDate = moment().startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().endOf('month').format("YYYY-MM-DD");

        if(user && user.length > 0 ){
          vm.loggedUser = JSON.parse(user);

        }else {
          vm.$router.push("/");
        }
      },
      computed: {
        filteredCheques() {
          let vm = this;
          if (vm.chequesSearch.length > 0) {
            let chequesList = [];
            for (let i = 0; i < vm.Cheques.length; i++) {
              let t = vm.Cheques[i];
              let found = false;
              if (t.Data.dealerName.toUpperCase().indexOf(vm.chequesSearch.toUpperCase()) > -1) {
                found = true;
              }
              if (t.Data.amount.toUpperCase().indexOf(vm.chequesSearch.toUpperCase()) > -1) {
                found = true;
              }
              // if (t.Time.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              //   found = true;
              // }
              if (found) {
                chequesList.push(t);
              }
            }
            return chequesList;
          } else {
            return vm.Cheques;
          }
        }
      },
      methods:{

        logout(){
          // console.log("Logout Click");
          let vm = this;
          
          vm.loggedUser = null;
          localStorage.removeItem("User");
          vm.$router.push("/");

        },
        // getUserData(){
        //   let vm = this;
        //   console.log(vm.loggedUser)
        //   db.collection("Users").doc(vm.loggedUser).get()
        //   .then((result) => {
        //     if(result.size > 0){
        //       result.forEach((doc) => {
        //         let user = doc.data();
        //         console.log(user)
        //       })
        //     }
            
        //   }).catch((err) => {
        //         console.log("Error : ");
              
        //       });
    
        // },
        getUserData(){
          
          let vm = this;
          // console.log("Loading user data >>>" , vm.loggedUser);

          db.collection("Users").doc(vm.loggedUser.userID).onSnapshot((doc)=> {
            if (doc.exists){
                let userData = doc.data();
                // console.log("vm.userData =" + JSON.stringify(userData));
                if(userData.active == false){
                  vm.$router.push("/")
                }
            }
        })
          // db.collection("Users").doc(vm.loggedUser).get().then((result)=>{
          //   for(let a = 0; a < result.size; a++){
          //     let userId = result.docs[a].id;
          //     let user = result.docs[a].data();
          //     //
          //     console.log(user)
          //     vm.Users.push({
          //       ID: userId,
          //       username: user.dealerName,
          //       active: user.active,
          //       firstName: user.firstName,
          //       lastName: user.lastName,
          //       profileImg: user.profileImg,
          //       password: user.password,
          //       });
                
  
  
          //   }
          // }).catch((error)=>{
          //   console.log("Error Loading User", error)
          // })
        },

      loadChequesSum(){
        let vm = this;
        vm.Cheques = [];
        vm.totalCheques = 0;
        vm.chequesCounter = 0;
        vm.chequesFalse = 0;
        vm.chequesTrue = 0;
        db.collection("cheques").where('date','>=', vm.fromDate).where('date','<=', vm.toDate).orderBy("date","desc").get().then((result)=>{
            for(let a = 0; a < result.size; a++){
            let chequeId = result.docs[a].id;
            let cheque = result.docs[a].data();
            vm.Cheques.push({
              ID: chequeId,
              dealerName: cheque.dealerName,
              amount: cheque.amount,
              date: cheque.date,
              createdDate: cheque.createdDate,
              checked: cheque.checked,
              });
              vm.totalCheques = vm.totalCheques += cheque.amount;
              vm.chequesCounter = result.size;
              if(cheque.checked == false){
                vm.chequesFalse = vm.chequesFalse += cheque.amount
              }
              if(cheque.checked == true){
                vm.chequesTrue = vm.chequesTrue += cheque.amount
              }

              // console.log(vm.totalCheques)

          }
          

        }).catch((error)=>{
            console.log("Error Loading Products", error)
        })
    },
    loadExpenses(){
      let vm = this;
      vm.Expenses = [];
      vm.totalExpenses = 0;
      db.collection("Expenses").where('date','>=', vm.fromDate).where('date','<=', vm.toDate).orderBy("date","desc").get().then((result)=>{
          for(let a = 0; a < result.size; a++){
          let expenseId = result.docs[a].id;
          let expense = result.docs[a].data();
          vm.Expenses.push({
            ID: expenseId,
            dealerName: expense.dealerName,
            amount: expense.amount,
            date: expense.date,
            createdDate: expense.createdDate,
            checked: expense.checked,
            note : expense.note,
            image: expense.image
            });
            vm.totalExpenses = vm.totalExpenses += expense.amount;
            // console.log(vm.totalExpenses)

        }
        

      }).catch((error)=>{
          console.log("Error Loading Products", error)
      })
  },



      }
    })
  }


/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js